import { LoggerInterface } from "@interfaces/LoggerInterface";
import { WidgetInterface } from "@interfaces/WidgetInterface";

import InstagramGalleryServiceMainProductPageAdapter from "./adapters/InstagramGalleryServiceMainProductPageAdapter";
import InstagramPostsServiceProductPageAdapter from "./adapters/InstagramPostsServiceProductPageAdapter";
import { PRODUCT_PAGE_WIDGET } from "./constants";
import InstagramGalleryWidget from "./InstagramGalleryWidget";
import { InstagramGalleryWidgetConfigInterface } from "./InstagramGalleryWidgetConfig";

class InstagramGalleryProductPageWidget
    extends InstagramGalleryWidget
    implements WidgetInterface
{
    galleryServiceAdapter: InstagramGalleryServiceMainProductPageAdapter;
    postsServiceAdapter: InstagramPostsServiceProductPageAdapter;
    constructor(
        config: InstagramGalleryWidgetConfigInterface,
        logger: LoggerInterface
    ) {
        super(
            {
                ...config,
                customSettings: {
                    ...config.customSettings,
                    forceDisabledStories: true,
                },
            },
            logger,
            PRODUCT_PAGE_WIDGET
        );
        if (!config.galleryId) {
            throw new Error(
                "fail on trying init InstagramGalleryProductPageWidget galleryId is required"
            );
        }
        this.galleryServiceAdapter =
            new InstagramGalleryServiceMainProductPageAdapter(
                this.galleryService,
                config.galleryId
            );
        if (!config.productId) {
            throw new Error(
                "fail on trying init InstagramGalleryProductPageWidget productId is required"
            );
        }
        this.postsServiceAdapter = new InstagramPostsServiceProductPageAdapter(
            this.postsService,
            config.productId
        );
    }
}

export default InstagramGalleryProductPageWidget;
